module.exports = __webpack_public_path__ + "static/media/Karthus.b9884c94.png";